<template>
  <v-card>
    <v-card-text class="pa-0">
      <v-row>
        <v-col cols="12">
          <v-stepper v-model="step" class="elevation-0 transparent">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" step="1">Audios</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">NLP</v-stepper-step>
            </v-stepper-header>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-row justify="center"  >
                  <v-col cols="12">
                    <h3 class="text-center">Transcripción</h3>
                    <p class="text-center">Carga los archivos a ser procesados</p>
                    <p class="text-center">
                      Sólo se permiten archivos
                      <b>.wav</b> y
                      <b>.mp3</b> cada audio debe ser de máximo 20 Mb
                    </p>
                  </v-col>
                </v-row>
                <v-row ref="filesForm">
                  <!-- <input -->
                  <!--   type="file" -->
                  <!--   multiple="multiple" -->
                  <!--   style="display: none" -->
                  <!--   ref="fileInput" -->
                  <!--   :accept="this.acceptedFiles" -->
                  <!--   @change="onFilePicked" -->
                  <!-- > -->
                  <!-- <v-flex xs6 text-xs-center> -->
                  <!--   <v-btn style="cursor: pointer" color="primary" @click="$refs.fileInput.click()"> -->
                  <!--     <v-icon left>insert_drive_file</v-icon> -->
                  <!--     Cargar{{importedFiles.length > 0 ? ' más ' : ' '}}archivos -->
                  <!--   </v-btn> -->
                  <!-- </v-flex> -->
                  <v-col class="text-center" cols="12" >
                    <DropZoneFileUpload v-if="mounted" ref="dropZoneFileUpload" :hiddenInputContainer="$refs.filesForm" :acceptedFiles="this.acceptedFiles" @filesAdded="onFilePicked"/>
                  </v-col>
                  <v-col cols="12" v-if="importedFiles.length > 0">
                    <v-row justify="center"  >
                      <v-col cols="12">
                        <v-subheader class="text-center">Archivos de Audio</v-subheader>
                      </v-col>
                      <v-col cols="12">
                        <v-list>
                          <v-list-item v-for="(importedFile, i) in importedFiles" :key="i">
                            <v-list-item-action>
                              <v-icon>mic</v-icon>
                            </v-list-item-action>
                            <v-list-item-title>{{importedFile.name}}</v-list-item-title>
                            <v-list-item-action
                              style="cursor: pointer"
                              @click="removeAudio(importedFile, i)"
                            >
                              <v-icon>clear</v-icon>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-row v-if="loading">
                  <v-col class="text-center" cols="12" >
                    <v-progress-linear :active="loading" :indeterminate="loading"></v-progress-linear>
                  </v-col>
                </v-row>
                <v-form v-else ref="uploadAudioForm" lazy-validation>
                  <v-col class="d-flex" cols="12" sm="6" >
                    <v-select
                      :rules="[rules.required]"
                      :items="['1', '2', '3', '4', '5', '6', '7', '8']"
                      label="Número de interlocutores en el audio"
                    ></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="6" >
                    <v-checkbox v-model="detectWaitCurtain" label="Detectar cortina de espera"></v-checkbox>
                  </v-col>
                  <v-col cols="12" v-if="detectWaitCurtain">
                    <v-textarea
                      label="Texto de la cortina"
                      hint="Ingresa el texto de la cortina a ignorar en el audio"
                      :rules="[rules.required]"
                    ></v-textarea>
                  </v-col>
                </v-form>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-col cols="12">
                  <h3 class="text-center">Selecciona Tags de intereses</h3>
                </v-col>
                <v-col cols="12">
                  <h3 class="text-center">Selecciona Cuántos interlocutores</h3>
                </v-col>
                <v-col cols="12">
                  <v-btn>Seleccionar tags usados recientemente</v-btn>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="selectedInterests"
                    :items="interestsProcessAudios"
                    deletable-chips
                    label="Tags de intereses"
                    multiple
                    clearable
                    chips
                    dense
                    no-data-text="No se encontraron intereses"
                    :menu-props="{maxHeight: 200}"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-btn>Crear nuevo tag</v-btn>
                </v-col>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider class="my-1"></v-divider>
    <v-card-actions>
      <v-btn text color="error" @click="cancel()">Cancelar</v-btn>
      <v-spacer></v-spacer>
      <v-btn v-if="importedFiles.length > 0" @click="removeAllFiles" text color="error" class="mx-2">
        <v-icon left>delete</v-icon>
        Eliminar Selección
      </v-btn>
      <v-btn v-if="step > 1" color="primary" text @click="backStep()">Volver</v-btn>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-btn
              color="primary"
              class="float-right"
              @click="updateStep()"
              :loading="loading"
              :disabled="!areFilesUploaded || (step === 3 && !selectedInterests.length)"
            >
              <span v-if="step === 2" class="hidden-xs-only">Analizar</span>
              <span v-else class="hidden-xs-only">Continuar</span>
              <v-icon v-if="step < 2" dark>keyboard_arrow_right</v-icon>
            </v-btn>
          </div>
        </template>
        <span v-if="!areFilesUploaded">Ingresa por lo menos un archivo para continuar</span>
        <span v-else>Siguiente paso</span>
      </v-tooltip>
    </v-card-actions>
  </v-card>
</template>

<script>
// import notifications from '@/libs/notifications'
import { mapState } from 'vuex'
import rules from '@/libs/rules'
import notifications from '@/libs/notifications'
import DropZoneFileUpload from '@/components/ui/DropZoneFileUpload'

export default {
  components: {
    DropZoneFileUpload
  },
  mounted () {
    this.mounted = true
  },
  computed: {
    ...mapState({
      listsPersons: state => state.listsPersons.listsPersons,
      loading: state => state.listsPersons.loadingNewSpeechStepper
    })
  },
  data () {
    return {
      step: 1,
      acceptedFiles: '.wav,.mp3',
      importedFiles: [],
      audiosTranscriptToText: [],
      totalAudiosTranscriptToText: 0,
      selectedInterests: [],
      interestsProcessAudios: [
        'Promedio tiempo de llamada',
        'Porcentaje de confianza',
        'Participación por género',
        'Porcentaje de silencio',
        'Porcentaje de ventas',
        'Promedio de llamada con venta',
        'Competidores mencionados',
        'Razón de mención de competidor',
        'Promedio de inconformidad',
        'Tipo de inconformidad',
        'Solicitudes',
        'Porcentaje de rechazo'
      ],
      detectWaitCurtain: false,
      areFilesUploaded: true,
      mounted: false,
      rules: rules
    }
  },
  methods: {
    onFilePicked (files) { // event) {
      // const files = event.target.files
      // const files = this.$refs.fileInput.files
      // console.log('files')
      // console.log(files)
      if (files.length > 0) {
        for (var i = 0; i < files.length; i++) {
          let file
          try {
            file = files.item(i)
          } catch (__) {
            file = files[i]
          }
          console.log('file')
          console.log(file)
          // console.log(file.accepted)
          // while (file.status !== 'queued') {}
          if (file.accepted) {
            this.importedFiles.push(file)
          } else {
            notifications.error(`El archivo ${file.name} no fue aceptado`)
          }
        }
      }
    },
    removeAudio (audio, idx) {
      this.importedFiles.splice(idx, 1)
    },
    backStep () {
      if (this.step > 0) {
        this.step -= 1
      }
    },
    updateStep () {
      if (this.step === 1) {
        this.step = 2
      } else if (this.step === 2) {
        if (!this.$refs.uploadAudioForm.validate()) return
        const fd = new FormData()
        for (let i = 0; i < this.importedFiles.length; i++) {
          fd.append('files', this.importedFiles[i])
        }
        // console.log(this.importedFiles)
        // dispatch uploadAudio
        this.$store.dispatch('uploadAudios', { filesForm: fd })
        const timeout = () => {
          notifications.success('Archivos subidos con éxito')
          this.cancel()
        }
        setTimeout(timeout, 3000)
      }
    },
    removeAllFiles () {
      this.$refs.dropZoneFileUpload.removeAllFiles()
      this.importedFiles = []
    },
    cancel () {
      this.removeAllFiles()
      this.$emit('cancel')
    }
  },
  watch: {
    importedFiles (value) {
      if (value.length > 0) this.areFilesUploaded = true
    }
  }
}
</script>
